import { render, staticRenderFns } from "./supplierLogisticsManage.vue?vue&type=template&id=21555e2f&scoped=true"
import script from "./supplierLogisticsManage.vue?vue&type=script&lang=js"
export * from "./supplierLogisticsManage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21555e2f",
  null
  
)

export default component.exports